<template>
  <TabGroup :selected-index="selectedIndex" @change="changeTab">
    <slot />
  </TabGroup>
</template>

<script setup lang="ts">
  import { TabGroup } from '@headlessui/vue'
  import { provide, toRef } from 'vue'
  import { tabBarGroupKey, useTabBarQuery, type TabBarItem } from './use-tab-bar-query'

  const props = defineProps<{
    tabItems: TabBarItem[]
    /** Used when the URL has no matching tab. Falls back to the first tab. */
    defaultTabId?: string
  }>()

  const { selectedIndex, changeTab } = useTabBarQuery(
    toRef(props, 'tabItems'),
    toRef(props, 'defaultTabId'),
  )

  provide(tabBarGroupKey, {
    selectedIndex,
  })
</script>
